import React from "react";
import { MERCH, STORE_URL } from "../mock";
import { fbTrack } from "../lib/track";

const Merch = () => {
  return (
    <section id="merch" className="relative bg-gradient-to-b from-[#0a0410] via-[#150826] to-[#0a0410] py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#c9a24a] tracking-[0.3em] uppercase text-xs mb-3">Official Store</p>
          <h2 className="heading-display gold-text text-4xl md:text-6xl">THE COLLECTION</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
          {MERCH.map((item) => (
            <a
              key={item.id}
              href={item.link || STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                const value = parseFloat((item.price || "").replace(/[^0-9.]/g, "")) || 0;
                fbTrack("ViewContent", {
                  content_name: item.title,
                  content_category: "Merch",
                  content_type: "product",
                  value,
                  currency: "USD",
                });
                if (item.link) {
                  fbTrack("InitiateCheckout", {
                    content_name: item.title,
                    content_category: "Merch",
                    num_items: 1,
                    value,
                    currency: "USD",
                  });
                }
              }}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-md bg-white/[0.03] ring-1 ring-[#d4af37]/10 aspect-square">
                {item.badge && (
                  <span className="absolute top-3 left-3 z-10 text-[10px] tracking-[0.15em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] px-2.5 py-1 rounded-full shadow-md">
                    {item.badge}
                  </span>
                )}
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0410] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <div className="pt-4 text-center">
                <h3 className="text-white text-sm md:text-base font-medium leading-snug">{item.title}</h3>
                <p className="text-[#c9a24a] mt-1">{item.price}</p>
                {item.description && (
                  <p className="text-neutral-400 text-xs leading-relaxed mt-3 text-left">
                    {item.description}
                  </p>
                )}
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-14">
          <a
            href={STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              fbTrack("InitiateCheckout", {
                content_name: "Shop Now (The Collection)",
                content_category: "Merch",
              })
            }
            className="inline-flex items-center px-10 py-4 text-sm tracking-[0.2em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] rounded-sm hover:from-[#ffe38f] hover:to-[#d4af37] transition-all duration-300 shadow-[0_0_30px_rgba(212,175,55,0.3)] hover:-translate-y-0.5"
          >
            Shop Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Merch;
